import { joinX } from './joinX';
import { slotX } from './slotX';
import { sortX } from './sortX';
import { toXY } from './toXY';

export const XYObject = {
  joinX,
  slotX,
  sortX,
  toXY,
};
